import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routes } from 'core/utils/routes'
import { deleteConfigMap } from 'k8s/components/config-maps/new-actions'
import usePluginRouter from 'core/hooks/usePluginRouter'

export default function DeleteConfigMapDialog({ rows: [configMap], onClose }) {
  const { history } = useReactRouter()
  const { currentPluginId } = usePluginRouter()
  const routePath = currentPluginId === 'kubevirt' ? 'kubevirtConfiguration' : 'configuration'
  const { update: deleteFn, updating: deletingConfigMap } = useUpdateAction(deleteConfigMap)

  const handleDelete = useCallback(async () => {
    await deleteFn(configMap)
    onClose(true)
    history.push(routes[routePath].configMaps.list.path())
  }, [configMap, routePath])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Remove Config Map "${configMap?.name}" ?`}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingConfigMap}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingConfigMap}>
            Delete
          </Button>
        </>
      }
    >
      <Text variant="body2">Your data will be lost since this action cannot be undone.</Text>
    </Modal>
  )
}
